var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngelska = function SvgEngelska(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00263E",
    strokeWidth: 1.5,
    d: "m6.937 15.763 2.112-2.113H14a3.25 3.25 0 0 0 3.25-3.25V4A3.25 3.25 0 0 0 14 .75H4A3.25 3.25 0 0 0 .75 4v6.4A3.25 3.25 0 0 0 4 13.65h2.51v1.936a.25.25 0 0 0 .427.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00263E",
    d: "M2.631 9.36V4.721h3.44v.785H3.568v1.028h2.329v.782H3.568v1.262h2.591v.782zm4.332 0V4.721h.911L9.773 7.82V4.721h.87V9.36h-.94l-1.87-3.025V9.36zm6.828-1.705v-.782h2.019v1.848q-.294.285-.853.501t-1.131.217q-.727 0-1.269-.305a1.94 1.94 0 0 1-.813-.874 2.8 2.8 0 0 1-.272-1.235q0-.724.304-1.288.303-.562.889-.864.445-.23 1.11-.23.864 0 1.35.362t.625 1.001l-.93.174a.98.98 0 0 0-.37-.54 1.1 1.1 0 0 0-.675-.197q-.613 0-.976.39-.362.388-.362 1.154 0 .825.367 1.239.367.413.962.413.294 0 .59-.116a2 2 0 0 0 .508-.28v-.588H13.79z"
  }))));
};
export default SvgEngelska;